<script>
  import "../node_modules/materialize-css/dist/css/materialize.min.css";
  import "../node_modules/materialize-css/dist/js/materialize.min.js";

  import { Router, navigate, Route } from "svelte-routing";
  import { account, appSession } from "./stores/app.js";
  import Login from "./pages/Login.svelte";
  import Scaffold from "./pages/Scaffold.svelte";
  import Welcome from "./pages/Welcome.svelte";
  import SubscriptionExpired from "./pages/SubscriptionExpired.svelte";
  import PasswordForgot from "./pages/PasswordForgot.svelte";
  import PasswordReset from "./pages/PasswordReset.svelte";
  import Invite from "./pages/Invite.svelte";

  export let googleMapsReady;

  function LoginHandler(event) {
    appSession.set({
      authorisationToken: event.detail.authorisationToken,
      pilotId: event.detail.pilotId,
    });

    account.set({
      name: event.detail.name,
      email: event.detail.email,
      subscriptionRequired: event.detail.subscriptionRequired,
      subscriptionExpired: event.detail.subscriptionExpired,
    });
  }

  function LogoutHandler(event) {
    setTimeout(() => {
      appSession.set({ authorisationToken: null, pilotId: null });
      account.set({
        name: null,
        email: null,
        subscriptionRequired: true,
        subscriptionExpired: true,
      });
    }, 750);
  }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return null;
  }

  let hash = null;
  let inviteCode = null;
  let redirect = getQueryVariable("redirect");

  switch (redirect) {
    case "passwordreset":
      hash = getQueryVariable("hash");
      navigate("passwordreset");
      break;
    case "invite":
      inviteCode = getQueryVariable("code");
      navigate("invite");
      break;
    default:
      break;
  }
</script>

<svelte:head>
	<script defer async
	src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCm3pUNNW3KrVxJK7oxdDmhEYjTpMW3GKk&callback=initMap">
	</script>
</svelte:head>

<Router>
  {#if $appSession && $appSession.authorisationToken == null}
    <Route path="/">
      <Login on:login={LoginHandler} />
    </Route>
    <Route path="passwordrecover" component={PasswordForgot} />
    <Route path="passwordreset" component={PasswordReset} {hash} />
    <Route path="invite">
      <Invite on:login={LoginHandler} {inviteCode} />
    </Route>
  {/if}

  {#if $appSession && $appSession.authorisationToken != null}
    {#if $account.subscriptionRequired}
      <Welcome on:logout={LogoutHandler} />
    {:else if $account.subscriptionExpired}
      <SubscriptionExpired on:logout={LogoutHandler} />
    {:else}
      <Scaffold on:logout={LogoutHandler} {googleMapsReady} />
    {/if}
  {/if}
</Router>
